// src/ui/steps/step0-scope.jsx — Kies type opdracht (film/festival); festival vraagt extra de vorm (zzp/loondienst)
// Interne substappen: 'a' = type-keuze, 'b' = vorm-keuze (alleen festival, eigen scherm met terug-knop).
import React from "react";
import { FW, FwButton } from "../primitives";

export const StepScope = ({ state, setState, next }) => {
  // Bij terug-navigatie vanuit step 1 met al gekozen festival-vorm: open direct substap b.
  const [substap, setSubstap] = React.useState(
    state.type === "festival" && state.vorm ? "b" : "a",
  );

  const pickType = (t) => {
    setState(s => {
      const base = s.type === t
        ? { ...s, type: t }
        : { ...s, type: t, omschrijving: "", rollen: [], vorm: undefined };
      if (t === "film") {
        setTimeout(next, 150);
        return { ...base, perspectief: "uitvoerder" };
      }
      // Festival: vorm-keuze op aparte substap (b).
      setTimeout(() => setSubstap("b"), 150);
      return base;
    });
  };

  const pickVorm = (v) => {
    // Festival: vorm-keuze impliceert "ik bereken voor mezelf".
    // Bij wisseling tussen zzp ↔ loondienst worden de werkdagen-/
    // dienstverband-state per rol gewist; de rol en zwaarteniveau blijven.
    setState(s => {
      const vormGewijzigd = s.vorm && s.vorm !== v;
      const rollen = vormGewijzigd
        ? (s.rollen || []).map(r => ({
            ...r,
            werkdagen: undefined,
            dienstverband: undefined,
            periodiek: undefined,
          }))
        : s.rollen;
      return { ...s, type: "festival", vorm: v, perspectief: "uitvoerder", rollen };
    });
    setTimeout(next, 150);
  };

  return (
    <div>
      {substap === "b" && (
        <div style={{ display: "inline-flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
          <button
            onClick={() => setSubstap("a")}
            aria-label="Terug naar type-keuze"
            style={{
              display: "inline-flex", alignItems: "center", gap: 6,
              padding: "4px 12px 4px 9px", borderRadius: 6,
              background: FW.white, color: FW.navy, border: `1px solid ${FW.taupe}`,
              fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5,
              fontFamily: "var(--font-sans)", cursor: "pointer",
              transition: "background .15s",
            }}
            onMouseEnter={e => { e.currentTarget.style.background = FW.beige2; }}
            onMouseLeave={e => { e.currentTarget.style.background = FW.white; }}
          >
            <i className="ri-arrow-left-line" style={{ fontSize: 14 }} /> Terug
          </button>
          <div style={{ padding: "4px 10px", borderRadius: 6,
            background: FW.navy, color: FW.yellow, fontSize: 12, fontWeight: 700,
            textTransform: "uppercase", letterSpacing: 0.5 }}>Filmfestival</div>
        </div>
      )}
      {substap === "a" && (
        <div style={{ marginBottom: 8, display: "inline-flex", gap: 8, alignItems: "center", color: FW.navy, opacity: .75 }}>
          <i className="ri-heart-line" style={{ fontSize: 18 }} />
          <span style={{ fontSize: 15, fontWeight: 600 }}>Waarmee kunnen we je helpen?</span>
        </div>
      )}
      <h1 className="step-hero" style={{ fontSize: 52, lineHeight: 1.1, margin: "8px 0 12px", letterSpacing: "-0.01em" }}>
        <span style={{ fontWeight: 700 }}>Bereken;</span>{" "}
        <span style={{ fontWeight: 300 }}>een eerlijk openingsbod in een paar stappen.</span>
      </h1>
      <p className="step-hero-sub" style={{ fontSize: 18, maxWidth: 640, color: FW.navy2, marginBottom: 32, lineHeight: 1.45 }}>
        We lopen samen je opdracht door. Je ziet bij elke stap waarop we de berekening baseren — die aannames kun je later altijd aanpassen.
      </p>

      {substap === "a" ? (
        <>
          <div style={{ fontSize: 14, fontWeight: 700, color: FW.navy, marginBottom: 12, textTransform: "uppercase", letterSpacing: 0.5, opacity: .75 }}>
            1. Om wat voor opdracht gaat het?
          </div>
          <div className="scope-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, maxWidth: 760 }}>
            <button onClick={() => pickType("film")} className="scope-card" style={scopeCard(FW.mint)} {...cardHoverProps(SCOPE_BASE_SHADOW)}>
              <IllusFilm />
              <div className="scope-card-title" style={{ fontSize: 24, fontWeight: 700, marginTop: 12 }}>Ik werk aan een<br/>filmproductie</div>
              <div style={{ fontSize: 14, opacity: .8, marginTop: 8 }}>Korte film, speelfilm, documentaire, serie, animatie</div>
              <div style={{ marginTop: "auto", paddingTop: 20, fontSize: 18, fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 10 }}>
                Kies <span style={arrowWell()}>→</span>
              </div>
            </button>
            <button onClick={() => pickType("festival")} className="scope-card" style={scopeCard(FW.cyan)} {...cardHoverProps(SCOPE_BASE_SHADOW)}>
              <IllusFestival />
              <div className="scope-card-title" style={{ fontSize: 24, fontWeight: 700, marginTop: 12 }}>Ik werk aan een<br/>filmfestival</div>
              <div style={{ marginTop: "auto", paddingTop: 20, fontSize: 18, fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 10 }}>
                Kies <span style={arrowWell()}>→</span>
              </div>
            </button>
          </div>
        </>
      ) : (
        <>
          <div style={{ fontSize: 14, fontWeight: 700, color: FW.navy, marginBottom: 12, textTransform: "uppercase", letterSpacing: 0.5, opacity: .75 }}>
            2. Werk je als zzp'er of in loondienst?
          </div>
          <div className="scope-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, maxWidth: 760 }}>
            <button onClick={() => pickVorm("zzp")} className="scope-card" style={vormCard()} {...cardHoverProps(VORM_BASE_SHADOW)}>
              <i className="ri-user-line" style={{ fontSize: 28, color: FW.navy }} />
              <div style={{ fontSize: 20, fontWeight: 700, marginTop: 10 }}>Ik werk als zzp'er</div>
              <div style={{ fontSize: 14, opacity: .8, marginTop: 8, color: FW.navy2 }}>
                Ik factureer als zelfstandige aan het festival.
              </div>
              <div style={{ marginTop: "auto", paddingTop: 16, fontSize: 16, fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 10 }}>
                Kies <span style={arrowWell()}>→</span>
              </div>
            </button>
            <button onClick={() => pickVorm("loondienst")} className="scope-card" style={vormCard()} {...cardHoverProps(VORM_BASE_SHADOW)}>
              <i className="ri-briefcase-line" style={{ fontSize: 28, color: FW.navy }} />
              <div style={{ fontSize: 20, fontWeight: 700, marginTop: 10 }}>Ik werk in loondienst</div>
              <div style={{ fontSize: 14, opacity: .8, marginTop: 8, color: FW.navy2 }}>
                Ik krijg een arbeidsovereenkomst van het festival.
              </div>
              <div style={{ marginTop: "auto", paddingTop: 16, fontSize: 16, fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 10 }}>
                Kies <span style={arrowWell()}>→</span>
              </div>
            </button>
          </div>
        </>
      )}

      <div style={{ marginTop: 40, color: FW.navy2, fontSize: 14, maxWidth: 640 }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "10px 14px", background: FW.beige2, borderRadius: 999 }}>
          <i className="ri-shield-check-line" style={{ fontSize: 16 }} />
          <span>We hanteren de Fair Pay richtlijn 2026 — zzp-starttarieven, inclusief opslagfactor (74,45% Film/AV of 69,26% Festival).</span>
        </div>
      </div>

      {substap === "b" && (
        <div className="step-nav" style={{ marginTop: 32, display: "flex", justifyContent: "space-between" }}>
          <FwButton variant="ghost" arrow={false} onClick={() => setSubstap("a")}>← Terug</FwButton>
        </div>
      )}
    </div>
  );
};

const SCOPE_BASE_SHADOW = "0 4px 12px rgba(0,0,0,.06)";
const VORM_BASE_SHADOW = "0 2px 8px rgba(0,0,0,.04)";
const HOVER_SHADOW = "0 14px 30px rgba(0,0,0,.14)";

// Hover-feedback: kaart "tilt op" zodat 'ie als knop voelt; bij mouse-down een lichte druk-feedback.
const cardHoverProps = (baseShadow) => ({
  onMouseEnter: (e) => {
    e.currentTarget.style.transform = "translateY(-3px)";
    e.currentTarget.style.boxShadow = HOVER_SHADOW;
  },
  onMouseLeave: (e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = baseShadow;
  },
  onMouseDown: (e) => { e.currentTarget.style.transform = "translateY(-1px) scale(0.99)"; },
  onMouseUp:   (e) => { e.currentTarget.style.transform = "translateY(-3px)"; },
});

const scopeCard = (bg) => ({
  background: bg, border: "3px solid transparent",
  borderRadius: 24, padding: 28, textAlign: "left",
  color: FW.navy, cursor: "pointer", fontFamily: "var(--font-sans)",
  minHeight: 280, display: "flex", flexDirection: "column",
  transition: "transform .2s ease, box-shadow .2s ease",
  boxShadow: SCOPE_BASE_SHADOW,
});
const vormCard = () => ({
  background: FW.white,
  border: `1.5px solid ${FW.gray100}`,
  borderRadius: 24, padding: 24, textAlign: "left",
  color: FW.navy, cursor: "pointer", fontFamily: "var(--font-sans)",
  minHeight: 180, display: "flex", flexDirection: "column",
  transition: "transform .2s ease, box-shadow .2s ease",
  boxShadow: VORM_BASE_SHADOW,
});
const arrowWell = () => ({
  display: "inline-grid", placeItems: "center",
  width: 40, height: 40, borderRadius: 999,
  background: FW.navy, color: "#fff", fontSize: 18,
});

const IllusFilm = () => (
  <svg width="120" height="72" viewBox="0 0 120 72" fill="none" stroke={FW.navy} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="10" y="14" width="70" height="44" rx="4" />
    <polygon points="88,22 110,16 110,56 88,50" />
    <circle cx="18" cy="22" r="2" /><circle cx="26" cy="22" r="2" /><circle cx="18" cy="50" r="2" /><circle cx="26" cy="50" r="2" />
    <circle cx="45" cy="36" r="8" />
  </svg>
);
const IllusFestival = () => (
  <svg width="120" height="72" viewBox="0 0 120 72" fill="none" stroke={FW.navy} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 58 L60 14 L108 58 Z" />
    <path d="M30 58 L30 40 M50 58 L50 32 M70 58 L70 32 M90 58 L90 40" />
    <circle cx="60" cy="24" r="3" />
    <path d="M6 64 L114 64" />
  </svg>
);
